import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import {
  getInitials,
  getUserColorClass,
  sizeClasses,
} from '@/components/ui/UserBadge/utils';
import { cn } from '@/lib/utils';

interface UserAvatarProps {
  name?: string;
  recnum: number;
  loginname?: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xs';
  title?: string;
  style?: React.CSSProperties;
}

export function UserAvatar({
  name,
  recnum,
  loginname,
  className,
  size = 'md',
  title,
  style,
}: UserAvatarProps) {
  const initials = getInitials(name, loginname, recnum);
  const colorClass = getUserColorClass(recnum);

  return (
    <Avatar
      className={cn(sizeClasses[size], className)}
      title={title}
      style={style}
    >
      <AvatarFallback className={cn(colorClass)}>{initials}</AvatarFallback>
    </Avatar>
  );
}
